import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M0 9h5v11H0V9zm7-4h5v15H7V5zm7-5h5v20h-5V0z'],
  height: 20,
  width: 19,
});
